export default "__VITE_ASSET__DF90jhDy__"